const p = document.createElement('p')
p.textContent = 'Hello world!'
document.body.appendChild(p)